import { Component } from '@angular/core';
import { AlertContainer, Button, ModalAdapter } from '@malirang/front-share';

@Component({
  selector: 'app-conflict-confirm',
  templateUrl: './conflict-confirm.alert.html',
  imports: [Button, AlertContainer],
})
export class ConflictConfirmAlert extends ModalAdapter {
  confirm() {
    this.modalService.close('confirm');
  }
}
